import { useSentry } from '../composables/sentry'
import FirestoreService from './FirestoreService'
import { toBaseModel } from './BaseModelServiceInterfaceModel'

const { handleError } = useSentry()

const BaseModelService = {
  getBaseModel: async (uri: string | null = null) => {
    if (!uri)
      throw new Error('Base Model URI required')
    try {
      const res = await FirestoreService.getDocByUri({
        collection: 'base_models',
        uri
      })
      if (!res.success)
        throw new Error(`Issue retrieving base model ${uri}`)
      const model = toBaseModel(res.data)
      return {
        success: res.success,
        exists: res.exists,
        data: { ...model }
      }
    }
    catch (error: any) {
      handleError(error)
      return {
        success: false,
        exists: false,
        data: null
      }
    }
  },
}

export default BaseModelService
